import { TableColSave } from "./TableColSave";


  export class TableColSaveArray {
      tableColSave:TableColSave[] = [];

      constructor(){
        
      }
  }